import { Center, Text } from "@chakra-ui/react";
import Prev from "public/assets/images/pagination/prev";
import Next from "public/assets/images/pagination/next";
import { useMemo } from "react";
import { useMediaQuery } from "@chakra-ui/react";
interface PaginationProps {
  page: number;
  pages: number;
  loading?: boolean;
  setCurrentPage: (n: number) => void;
}

const Pagination = ({
  pages: totalPages,
  page: currentPage,
  setCurrentPage,
  loading,
}: PaginationProps) => {
  const [isLargerThan400] = useMediaQuery("(min-width: 400px)");

  const maxPages = useMemo(() => {
    return isLargerThan400 ? 10 : 9;
  }, [isLargerThan400]);

  const handlePageClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const renderForMobile = (i: number, startPage: number, endPage: number) => {
    if (isLargerThan400) {
      if (i !== startPage + 6) {
        return true;
      }
    } else {
      if (currentPage <= 4 && i + 2 === endPage) {
        return false;
      }
      if (i !== startPage + (totalPages - currentPage <= 4 ? 6 : 5)) {
        return true;
      }
    }
    return false;
  };

  const shouldRender = (i: number, startPage: number, endPage: number) => {
    if (
      totalPages - (isLargerThan400 ? 3 : 2) === i &&
      totalPages - currentPage <= 3
    ) {
      return false;
    }
    if (
      i !== startPage + 4 &&
      i !== startPage + 5 &&
      renderForMobile(i, startPage, endPage)
    ) {
      return true;
    }
    return false;
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const halfMaxPages = Math.floor(maxPages / 2);
    const startCorrection = halfMaxPages + 0; //4
    const endCorrection = halfMaxPages - 1; // 3
    let startPage = Math.max(1, currentPage - startCorrection);
    let endPage = Math.min(totalPages, currentPage + endCorrection);

    if (endPage - startPage + 1 < maxPages) {
      if (currentPage <= halfMaxPages) {
        endPage = Math.min(totalPages, maxPages);
      } else if (currentPage >= totalPages - halfMaxPages) {
        startPage = Math.max(1, totalPages - maxPages);
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      if (i === startPage + 3) {
        pageNumbers.push(
          <Center
            cursor="not-allowed"
            key={i}
            w="32px"
            h="32px"
            borderRadius="8px"
            borderColor={currentPage === i ? "#07C166" : "#AEDFCA"}
            borderWidth="1px"
          >
            <Text
              fontWeight={600}
              fontSize="14px"
              color={currentPage === i ? "#07C166" : "#000000"}
            >
              ...
            </Text>
          </Center>
        );
      } else if (shouldRender(i, startPage, endPage)) {
        pageNumbers.push(
          <Center
            cursor={currentPage !== i ? "pointer" : "not-allowed"}
            onClick={() => (currentPage !== i ? handlePageClick(i) : null)}
            key={i}
            w="32px"
            h="32px"
            borderRadius="8px"
            borderColor={currentPage === i ? "#07C166" : "#AEDFCA"}
            borderWidth="1px"
          >
            <Text
              fontWeight={600}
              fontSize="14px"
              color={currentPage === i ? "#07C166" : "#000000"}
            >
              {i}
            </Text>
          </Center>
        );
      }
    }
    return pageNumbers;
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  if (totalPages < 2) {
    return null;
  }
  return (
    <Center flexDirection="row" gap="8px" mb="64px" opacity={loading ? 0.5 : 1}>
      <Center
        cursor={currentPage !== 1 ? "pointer" : "not-allowed"}
        onClick={() => (currentPage !== 1 ? handlePrevClick() : null)}
        w="32px"
        h="32px"
        borderRadius="8px"
        borderColor={currentPage !== 1 ? "#07C166" : "#AEDFCA"}
        borderWidth="1px"
        backgroundColor={currentPage !== 1 ? "#07C166" : "#AEDFCA"}
      >
        <Prev isActive={currentPage !== 1} />
      </Center>
      {renderPageNumbers()}
      <Center
        cursor={currentPage !== totalPages ? "pointer" : "not-allowed"}
        onClick={() => (currentPage !== totalPages ? handleNextClick() : null)}
        w="32px"
        h="32px"
        borderRadius="8px"
        borderColor={currentPage !== totalPages ? "#07C166" : "#AEDFCA"}
        borderWidth="1px"
        backgroundColor={currentPage !== totalPages ? "#07C166" : "#AEDFCA"}
      >
        <Next isActive={currentPage !== totalPages} />
      </Center>
    </Center>
  );
};

export default Pagination;
